export const EMAIL_HI = 'hi@getjerry.com';
export const EMAIL_PRIVACY_POLICY = 'privacy@getjerry.com';
export const EMAIL_LEGAL = 'legal@getjerry.com';
